import React, {createContext, useContext, useState, useCallback} from 'react';
import {FullScreenLoading} from '../components/common/Loading';

interface GlobalSpinnerContextType {
    showSpinner: () => void;
    hideSpinner: () => void;
}

const GlobalSpinnerContext = createContext<GlobalSpinnerContextType>({
    showSpinner: () => {},
    hideSpinner: () => {},
});

export const useGlobalSpinner = () => useContext(GlobalSpinnerContext);

export const GlobalSpinnerProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
    const [count, setCount] = useState(0);

    const showSpinner = useCallback(() => {
        setCount(prev => prev + 1);
    }, []);

    const hideSpinner = useCallback(() => {
        setCount(prev => {
            const newCount = Math.max(0, prev - 1);
            // Log unbalanced calls in development mode
            if (prev === 0 && process.env.NODE_ENV === 'development') {
                console.warn(
                    'hideSpinner() called with no matching showSpinner(). ' +
                    'Check component code for unbalanced spinner calls.'
                );
            }
            return newCount;
        });
    }, []);

    return (
        <GlobalSpinnerContext.Provider value={{showSpinner, hideSpinner}}>
            {children}
            <FullScreenLoading show={count > 0} />
        </GlobalSpinnerContext.Provider>
    );
};
